import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

export const useDeleteCompany = (
  options?: UseMutationOptions<
    void,
    RequestErrorType,
    RequestTypes['deleteCompany']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.deleteCompany,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)

      options.onSuccess?.(...args)
    },
  })
}
